<template>
    <div class="stepper-input">
        <button class="icon min" type="button" @click.prevent="step(-1)" @mousedown.prevent />
        <hr>
        <button class="icon plus" type="button" @click.prevent="step(1)" @mousedown.prevent />
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StepperInput extends Vue {
    /** Price in cents */
    @Prop({ default: 0 })
    min!: number | null

    /** Price in cents */
    @Prop({ default: null })
    max!: number | null

    valid = true;

    /** Price in cents */
    @Prop({ default: 0 })
    value!: number

    get internalValue() {
        return this.value
    }

    set internalValue(val: number) {
        this.$emit("input", val)
    }

    // Limit value to bounds
    constrain(value: number): number {
        if (this.min !== null && value < this.min) {
            value = this.min;
        } else if (this.max !== null && value > this.max) {
            value = this.max;
        }
        return value
    }

    step(add: number) {
        if (!this.valid) {
            return;
        }
        const v = this.constrain(this.internalValue + add);
        this.internalValue = v
    }
}
</script>

<style lang="scss">
@use "sass:math";
@use "~@restofrit/scss/base/variables.scss" as *;
@use "~@restofrit/scss/components/inputs.scss" as *;

.stepper-input {
    display: inline-flex;
    flex-direction: row;
    background: $color-background-gray;
    border-radius: $border-radius;
    align-items: stretch;
    height: $input-height;

    hr {
        width: $border-width;
        flex-basis: $border-width;
        height: 19px;
        background: $color-gray-light;
        border-radius: math.div($border-width, 2); // Updated to use math.div()
        border: 0;
        outline: 0;
        transition: opacity 0.2s;
        align-self: center;
        margin: 0;
        padding: 0;
    }

    &:active {
        hr {
            transition: none;
            opacity: 0;
        }
    }

    button {
        padding: calc(($input-height - 30px) / 2) 14px; // Updated to use calc()
        border-radius: $border-radius;
        line-height: 30px;
        transition: background-color 0.2s;
        display: block;
        cursor: pointer;
        touch-action: manipulation;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        user-select: none;

        &:active {
            background: $color-background-primary;
            transition: none;
        }

        &:last-child {
            margin-left: -$border-width;
        }

        &:first-child {
            margin-right: -$border-width;
        }
    }
}
</style>